// extracted by mini-css-extract-plugin
module.exports = {"payAmount":"card-details-form_payAmount__3CNIM","cardForm":"card-details-form_cardForm__2c1K7"};